<template>
  <div class='line-wrap'>
    <div class='line-info' @click="onClick" v-bind:class="{ fault: getStatus}">
      {{lineInfo.라인명}}
    </div>
  </div>
</template>

<script>
export default {
  name: 'lineGrid',
  data: function () {
    return {
    }
  },
  props: {
    lineInfo: {
      type: Object,
      default: function () {
        return { 라인명: '조립1' }
      }
    }
  },
  components: {
  },
  computed: {
    getStatus () {
      if (this.lineInfo.status === 'FAULT') return true
      else return false
    }
  },
  created () {

  },
  mounted () {
  },
  updated () {
  },
  beforeDestroy: function () {

  },
  methods: {
    onClick (e) {
      if (this.lineInfo.seqId !== null) {
        this.$emit('selected-line', this.lineInfo.seqId)
      }
    }
  }
}
</script>

<style lang="scss">
.line-wrap {
  border: 0px solid gray;
  height: 100px;
  width: 140px;
  padding-top:10px;
  .line-info {
    margin: 0 auto;
    text-align: center;
    height: 80px;
    width: 120px;
    line-height: 80px;
    background-color: rgb(22, 189, 22);
    border-radius: 5px;
    color:white;
    font-size: 0.9rem;
  }
  .fault {
    background-color: rgb(253, 52, 52);
  }
}
</style>
